import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import CtaLink from 'components/essentials/Cta/CtaLink';
import notificationBannerHelper from 'components/consumer/NotificationBanner/utils';
import ProductImage from 'components/consumer/cart/components/ProductImage';
import useProtectionPlans from 'data-hooks/useProtectionPlans';
import IconProtectionPlan from 'components/icons/iconProtectionPlan';
import IconPetProtector from 'components/icons/iconPetProtector';
import LoadMoreButton from 'components/consumer/LoadMoreButton';
import ProtectionPlans from 'components/consumer/ProtectionPlans';
import useUserData from 'data-hooks/useUserData';
import UserProtectionPlanModal from '../UserProtectionPlanModal';
export const SelectedProtectionPlan = t0 => {
  const $ = _c(13);
  const {
    applied_protection_plan
  } = t0;
  let t1;
  if ($[0] !== applied_protection_plan.plan_name) {
    t1 = <span className="mr-[.7rem]">{applied_protection_plan.plan_name.includes("Pet Protector Plan") ? <IconPetProtector /> : <IconProtectionPlan />}</span>;
    $[0] = applied_protection_plan.plan_name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = applied_protection_plan.plan_name;
  let t3;
  if ($[2] !== applied_protection_plan.plan_price) {
    t3 = Intl.NumberFormat().format(applied_protection_plan.plan_price);
    $[2] = applied_protection_plan.plan_price;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== applied_protection_plan.plan_name || $[5] !== t3) {
    t4 = <span className="text-xs font-bold mr-4">5-year {t2}{" (+$"}{t3})</span>;
    $[4] = applied_protection_plan.plan_name;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span><CtaLink target="_blank" to="/furniture-protection-plan/" styling="link" noLinkPadding={true} color="brand" hasArrow={false} textClassName="!text-xs !font-bold">Details</CtaLink></span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <div className="flex w-full justify-between items-center max-[1023px]:flex-col max-[1023px]:items-start">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t6) {
    t7 = <div className="flex flex-row items-center bg-white mr-auto p-[5px] h-[60px] border border-solid border-gray-light7 max-[1023px]:w-full max-[1023px]:p-[5px] max-[1023px]:mt-2">{t1}{t6}</div>;
    $[10] = t1;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
SelectedProtectionPlan.propTypes = {
  applied_protection_plan: PropTypes.shape({
    plan_name: PropTypes.string,
    plan_price: PropTypes.bool
  })
};
const UserProtectionPlans = () => {
  const $ = _c(19);
  const {
    data: t0,
    actions: t1
  } = useProtectionPlans();
  const {
    error,
    loading,
    loadingMore,
    cartItems,
    hasLoadMore,
    isUpdateSuccess,
    purchaseErrorMessage
  } = t0;
  const {
    logout,
    loadMore,
    purchaseProtectionPlan,
    setIsUpdateSuccess,
    setPurchaseErrorMessage
  } = t1;
  const {
    isImpersonatingUser
  } = useUserData();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      isOpen: false,
      orderId: null,
      cartItem: null,
      selectedPlan: null
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [state, setState] = useState(t2);
  if (loading) {
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div>loading...</div>;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  if (error) {
    const code = get(error, "0.code");
    const message = get(error, "0.message");
    if (code === "AUTH_REQUIRED" || message && message.includes("JWT")) {
      logout();
      let t3;
      if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <Redirect to="/sign-in/" />;
        $[2] = t3;
      } else {
        t3 = $[2];
      }
      return t3;
    }
    let t3;
    if ($[3] !== error) {
      t3 = get(error, "0.message", "Failed to fetch the orders");
      $[3] = error;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return `Error!: ${t3}`;
  }
  if (isUpdateSuccess && state.selectedPlan) {
    notificationBannerHelper.showMsg("UserOrdersProtectionPlan", {
      planName: state.selectedPlan?.plan_name,
      productName: state.cartItem?.name
    });
    setState({
      ...state,
      isOpen: false,
      selectedPlan: null,
      orderId: null,
      cartItem: null
    });
    setIsUpdateSuccess(false);
    setPurchaseErrorMessage(null);
  }
  let t3;
  if ($[5] !== cartItems || $[6] !== hasLoadMore || $[7] !== isImpersonatingUser || $[8] !== loadMore || $[9] !== loadingMore) {
    const validCartItems = cartItems?.filter(_temp);
    const hasOrdersEligibleForProtectionPlans = validCartItems?.some(_temp2);
    t3 = <div>{hasOrdersEligibleForProtectionPlans ? <>{validCartItems?.map(item_0 => <div key={item_0.cart_id} className="bg-gray-light8 mb-12 border border-solid border-gray-light7"><div className="flex flex-row items-center p-[.7rem] h-[6.9rem] max-[1023px]:flex-col max-[1023px]:h-[unset]"><div className="flex flex-row mr-auto items-center w-1/2 max-[1023px]:w-full"><ProductImage product={item_0} width={100} trim="color" trimPad={20} containerClass="mr-8" /><div className="text-base font-bold"><div>{item_0.name}</div><div className="text-xs font-bold">{`Qty: ${item_0.quantity}`}</div></div></div>{item_0.applied_protection_plan ? <SelectedProtectionPlan applied_protection_plan={item_0.applied_protection_plan} /> : null}</div>{!item_0.applied_protection_plan && <ProtectionPlans eligiblePlans={[...item_0.available_protection_plans].sort(_temp3)} forPage="UserDashboardPP" onAdd={planId => {
            if (!isImpersonatingUser && planId) {
              setState({
                isOpen: true,
                cartItem: item_0,
                selectedPlan: item_0.available_protection_plans.find(plan => plan.plan_id === planId),
                orderId: item_0.order_id
              });
            }
          }} selectedPlan={item_0.applied_protection_plan} showInactiveProtectionPlan={true} />}</div>)}{!!hasLoadMore && <LoadMoreButton label="Load more" onClick={loadMore} loading={loadingMore} />}</> : <div className="delayed-display">You currently don’t have any orders that are eligible for a Protection Plan.</div>}</div>;
    $[5] = cartItems;
    $[6] = hasLoadMore;
    $[7] = isImpersonatingUser;
    $[8] = loadMore;
    $[9] = loadingMore;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== purchaseErrorMessage || $[12] !== purchaseProtectionPlan || $[13] !== setPurchaseErrorMessage || $[14] !== state) {
    t4 = state.isOpen && <UserProtectionPlanModal onClose={() => {
      setPurchaseErrorMessage(null);
      setState({
        ...state,
        isOpen: false,
        selectedPlan: null,
        orderId: null,
        cartItem: null
      });
    }} orderId={state.orderId} cartItem={state.cartItem} selectedPlan={state.selectedPlan} updateOrder={purchaseProtectionPlan} purchaseErrorMessage={purchaseErrorMessage} />;
    $[11] = purchaseErrorMessage;
    $[12] = purchaseProtectionPlan;
    $[13] = setPurchaseErrorMessage;
    $[14] = state;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default UserProtectionPlans;
function _temp(orderItem) {
  return !["Canceled", "Delivered", "Completed", "Replacement"].includes(orderItem.order_status);
}
function _temp2(item) {
  return item.applied_protection_plan || item.available_protection_plans?.length;
}
function _temp3(a, b) {
  return a.plan_id - b.plan_id;
}